<template>
  <section>
    <v-layout row wrap>
      <v-flex  offset-xs0 offset-sm3 offset-md9 offset-lg9 offset-xl9 >
        <v-btn class="mt-5" color="primary"  offset-xs8 offset-sm8 offset-md8 offset-lg8 offset-xl8  @click="volver()"><v-icon>arrow_back</v-icon>Volver</v-btn>
      </v-flex>

      <v-flex xs10 offset-xs1>
        <v-flex class="pb-5 ">
          <h3 class="display-3 mt-2">Curso: <span class="primary--text">{{curso.cource_title}}</span></h3>
          <h5>Descripción: <span class="secondary--text">{{curso.cource_description}}</span></h5>
          <p class="mt-4 body-1">Cantidad de alumnos inscritos: <strong>{{ curso.cantidadEstudiantesInscritos }}</strong></p>
        </v-flex>
        
        <v-layout row wrap>
          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="{name: 'showQualifications', params: { idCurso }}" class="enlace">
              <div class="white--text bordes" style="background-color: #03a9f4">
                <v-layout row align-center>
                  <v-flex xs3>
                      <v-layout column align-center justify-center >
                        <v-layout justify-space-around class="circulo">
                          <v-icon x-large style="color: #03a9f4">spellcheck</v-icon>
                        </v-layout>
                      </v-layout>
                  </v-flex>
                  <v-flex xs7>
                    <div class="headline white--text">Calificación</div>
                  </v-flex>
                </v-layout>
              </div>
            </router-link>
          </v-flex>

          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="{name: 'showMembersInCources', params: { idCurso }}" class="enlace">
              <div class="white--text bordes" style="background-color: #00bcd4">
                <v-layout row align-center>
                  <v-flex xs3>
                      <v-layout column align-center justify-center >
                        <v-layout justify-space-around class="circulo">
                          <v-icon x-large style="color: #00bcd4">people</v-icon>
                        </v-layout>
                      </v-layout>
                  </v-flex>
                  <v-flex xs7>
                    <div class="headline white--text">Miembros</div>
                  </v-flex>
                </v-layout>
              </div>
            </router-link>
          </v-flex>
          
          <v-flex xs4 class="px-2 py-2">
            <router-link  :to="{name: 'editCource', params: { idCurso }}" class="enlace">
              <div class="white--text bordes" style="background-color: #607d8b">
                <v-layout row align-center>
                  <v-flex xs3>
                      <v-layout column align-center justify-center >
                        <v-layout justify-space-around class="circulo">
                          <v-icon x-large style="color: #607d8b">list</v-icon>
                        </v-layout>
                      </v-layout>
                  </v-flex>
                  <v-flex xs7>
                    <div class="headline white--text">Contenido</div>
                  </v-flex>
                </v-layout>
              </div>
            </router-link>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="mt-5">
      <v-flex xs10 offset-xs1>
        <v-layout row wrap>
          
        </v-layout>
      </v-flex>
    </v-layout>


  </section>
</template>

<script>
import { courceService } from '@/services/Cource.service'

export default {
  data () {
    return {
      idCurso: 0,
      curso: 0
    }
  },
  mounted () {
    let vm = this
    vm.idCurso = vm.$route.params.id
    vm.loadCurso()
  },
  methods: {
    loadCurso () {
      let vm = this
      courceService.getById(vm.idCurso).then(data => {
        vm.curso = data.body
      })
    },
    verCalificacion (id) {
      this.$router.push({name: 'ShowQualification', params: {id: id}})
    },
    verCorreccion (id) {
      this.$router.push({name: 'preTest', params: {id: id}})
    },
    verMiembros (id) {
      this.$router.push({name: 'showCourse', params: {id: id}})
    },
    verPrueba (id) {
      this.$router.push({name: 'editEvaluacion', params: {id: id}})
    },
    volver () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
  .circulo {
      width: 60px;
      height: 60px;
      -moz-border-radius: 50%;
      -webkit-border-radius: 50%;
      border-radius: 50%;
      background: white;
  }

  .bordes {
    display: flex;
    align-items: center;
    border-radius: 20px;
    -moz-border-radius: 20px;
    -webkit-border-radius: 20px;
    border: 0px solid #000000;
    height: 130px;
  }
  .enlace {
    text-decoration:none;
  }
</style>


// WEBPACK FOOTER //
// src/components/Calificacion/ShowCourcesOption.vue